export const fontLetterSpacingTokens = () => {
  return 'unset';
};

export const fontLetterSpacingTokensNova = () => {
  return 'normal';
};
